import React from 'react';
import { Link } from 'react-router-dom';
import get from 'lodash/get';

import BackLink from 'rebook/apps/base/components/BackLink';
import pluralize from 'rebook/apps/utils/text/pluralize';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';
import CatalogItemImage from 'rebook/apps/catalog/components/CatalogItemImage';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import { Niche } from 'rebook/apps/catalog/models';

import styles from './style.scss';


const NicheHeader = ({ title, image, backLink, niche }) => {
  const theNiche = new Niche(niche);
  const totalBooksCounter = get(niche, 'counters.books', 0);
  const freeBooksCounter = get(niche, 'counters.free', 0);
  const audioBooksCounter = get(niche, 'counters.audio', 0);
  return (
    <React.Fragment>
      <BreadCrumbs links={[
        { text: 'Библиотека', url: '/catalog/' },
        { text: get(niche, 'name', ''), url: `/catalog/${get(niche, 'slug', '')}/` },
      ]} />
      <div className={styles.header}>
        {backLink && (
          <div className={styles.backLink}>
            <BackLink link={backLink.to}>
              <span className={styles.backLinkTitle}>{backLink.title}</span>
            </BackLink>
          </div>
        )}
        <div className={styles.headerContent}>
          <div className={styles.headerInner}>
            <h1>{title}</h1>
            <div className={styles.headerCount}>
              <div className={styles.link}>
                <Link to={theNiche.getBookListLink()} className="link">
                  {numberWithSpace(totalBooksCounter)}{' '}
                  {pluralize(totalBooksCounter, 'книга', 'книги', 'книг')}
                </Link>
              </div>
              {freeBooksCounter > 0 && (
                <React.Fragment>
                  <span className={styles.circle} />
                  <div className={styles.link}>
                    <Link to={theNiche.getFreeBookListLink()} className="link">
                      {numberWithSpace(freeBooksCounter)}{` `}
                      {pluralize(freeBooksCounter, 'бесплатная', 'бесплатные', 'бесплатных')}{` `}
                      {pluralize(freeBooksCounter, 'книга', 'книги', 'книг')}
                    </Link>
                  </div>
                </React.Fragment>
              )}
              {audioBooksCounter > 0 && (
                <React.Fragment>
                  <span className={styles.circle} />
                  <div className={styles.link}>
                    <Link to={theNiche.getAudioBookListLink()} className="link">
                      {numberWithSpace(audioBooksCounter)}{` `}
                      {pluralize(audioBooksCounter, 'аудиокнига', 'аудиокниги', 'аудиокниг')}
                    </Link>
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
          <div className={styles.headerImage}>
            <CatalogItemImage imageSrc={image} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NicheHeader;
